export enum QuestionConditionOperator {
  SINGLE = "SINGLE",
  AND = "AND",
  OR = "OR",
}

export interface QuestionConditionDependency {
  dependsOn: string;
  dependantValue: string;
  requiresAnswer: boolean;
}

export interface QuestionConditionsDto {
  operator: QuestionConditionOperator;
  dependencies: QuestionConditionDependency[];
}
